export const MORTGAGES_PATH = "mortgages";
export const LEASE_BUYOUT_PATH = "lease-buyout";

export const MORTGAGE_TYPE_FILTERING_KEY = "mortgageType";
export const CREDIT_SCORE_FILTERING_KEY = "creditQuality";
export const LOAN_AMOUNT_FILTERING_KEY = "loanAmountServiced";
export const MORTGAGE_PURCHASE_URL_PARAMETER = "mortgage-purchase";
export const MORTGAGE_REFINANCE_URL_PARAMETER = "mortgage-refinance";
export const PURCHASE_MORTGAGE_FILTER_VALUE = "purchase";
export const PURCHASE_MORTGAGE_FILTER_LABEL = "Purchase";
export const REFINANCE_MORTGAGE_FILTER_VALUE = "refinance";
export const REFINANCE_MORTGAGE_FILTER_LABEL = "Refinance";
export const EXCELLENT_CREDIT_FILTER_VALUE = "Excellent";
export const EXCELLENT_CREDIT_FILTER_LABEL = "Excellent (720-850)";
export const GOOD_CREDIT_FILTER_VALUE = "Good";
export const GOOD_CREDIT_FILTER_LABEL = "Good (680-719)";
export const FAIR_CREDIT_FILTER_VALUE = "Fair";
export const FAIR_CREDIT_FILTER_LABEL = "Fair (620-679)";
export const POOR_CREDIT_FILTER_VALUE = "Poor";
export const POOR_CREDIT_FILTER_LABEL = "Poor (300-619)";
export const UNDER_HUNDRED_K_FILTER_VALUE = "under_100k";
export const UNDER_HUNDRED_K_FILTER_LABEL = "Under $100k";
export const HUNDRED_TO_TWO_HUNDRED_K_FILTER_VALUE = "100k_200k";
export const HUNDRED_TO_TWO_HUNDRED_K_FILTER_LABEL = "$100k to $200k";
export const TWO_HUNDRED_TO_SIXTY_FOUR_HUNDRED_K_FILTER_VALUE = "200k_640k";
export const TWO_HUNDRED_TO_SIXTY_FOUR_HUNDRED_K_FILTER_LABEL =
	"$200k to $640k";
export const OVER_SIXTY_FOUR_HUNDRED_K_FILTER_VALUE = "over_640k";
export const OVER_SIXTY_FOUR_HUNDRED_K_FILTER_LABEL = "Over $640k";

export const RC_SITE_CONFIGURATION = {
	[MORTGAGES_PATH]: {
		preventRenderingCompanyListHeader: true,
		showFeaturedCompany: true,
	},
	[LEASE_BUYOUT_PATH]: {
		preventRenderingCompanyListHeader: true,
		showFeaturedCompany: true,
	},
};

export const MORTGAGE_FILTERING_CONFIG = {
	filteringSelects: [
		{
			title: "Mortgage Type",
			filteringKey: MORTGAGE_TYPE_FILTERING_KEY,
			options: [
				{
					value: PURCHASE_MORTGAGE_FILTER_VALUE,
					label: PURCHASE_MORTGAGE_FILTER_LABEL,
				},
				{
					value: REFINANCE_MORTGAGE_FILTER_VALUE,
					label: REFINANCE_MORTGAGE_FILTER_LABEL,
				},
			],
		},
		{
			title: "Credit Score",
			filteringKey: CREDIT_SCORE_FILTERING_KEY,
			options: [
				{
					value: EXCELLENT_CREDIT_FILTER_VALUE,
					label: EXCELLENT_CREDIT_FILTER_LABEL,
				},
				{
					value: GOOD_CREDIT_FILTER_VALUE,
					label: GOOD_CREDIT_FILTER_LABEL,
				},
				{
					value: FAIR_CREDIT_FILTER_VALUE,
					label: FAIR_CREDIT_FILTER_LABEL,
				},
				{
					value: POOR_CREDIT_FILTER_VALUE,
					label: POOR_CREDIT_FILTER_LABEL,
				},
			],
		},
		{
			title: "Loan Amount",
			filteringKey: LOAN_AMOUNT_FILTERING_KEY,
			options: [
				{
					value: UNDER_HUNDRED_K_FILTER_VALUE,
					label: UNDER_HUNDRED_K_FILTER_LABEL,
				},
				{
					value: HUNDRED_TO_TWO_HUNDRED_K_FILTER_VALUE,
					label: HUNDRED_TO_TWO_HUNDRED_K_FILTER_LABEL,
				},
				{
					value: TWO_HUNDRED_TO_SIXTY_FOUR_HUNDRED_K_FILTER_VALUE,
					label: TWO_HUNDRED_TO_SIXTY_FOUR_HUNDRED_K_FILTER_LABEL,
				},
				{
					value: OVER_SIXTY_FOUR_HUNDRED_K_FILTER_VALUE,
					label: OVER_SIXTY_FOUR_HUNDRED_K_FILTER_LABEL,
				},
			],
		},
	],
	placeholders: {
		// All 3 filters must be defined
		[MORTGAGE_PURCHASE_URL_PARAMETER]: {
			[MORTGAGE_TYPE_FILTERING_KEY]: {
				value: PURCHASE_MORTGAGE_FILTER_VALUE,
				label: PURCHASE_MORTGAGE_FILTER_LABEL,
			},
			[CREDIT_SCORE_FILTERING_KEY]: {
				value: "default",
				label: "All",
			},
			[LOAN_AMOUNT_FILTERING_KEY]: {
				value: "default",
				label: "All",
			},
		},
		[MORTGAGE_REFINANCE_URL_PARAMETER]: {
			[MORTGAGE_TYPE_FILTERING_KEY]: {
				value: REFINANCE_MORTGAGE_FILTER_VALUE,
				label: REFINANCE_MORTGAGE_FILTER_LABEL,
			},
			[CREDIT_SCORE_FILTERING_KEY]: {
				value: "default",
				label: "All",
			},
			[LOAN_AMOUNT_FILTERING_KEY]: {
				value: "default",
				label: "All",
			},
		},
		DEFAULT: {
			[MORTGAGE_TYPE_FILTERING_KEY]: {
				value: "default",
				label: "All",
			},
			[CREDIT_SCORE_FILTERING_KEY]: {
				value: "default",
				label: "All",
			},
			[LOAN_AMOUNT_FILTERING_KEY]: {
				value: "default",
				label: "All",
			},
		},
	},
};
